import { createReducer } from '@reduxjs/toolkit';

import { fetchMerchants } from './actions';

export default createReducer([], {
  [`${fetchMerchants}-success`]: (state, { payload: merchants }) => merchants,
});
